<app-header></app-header>
<div class="middle-content-wrap">
    <div class="globalheading dflex dflex_bet">
        <h2>Subscription Analytics</h2>
    </div>

    <div class="container-fluid" style="padding-bottom: 50px;">
        <div *ngIf="loading" class="text-center" style="padding: 50px;">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
            <p>Loading analytics data...</p>
        </div>

        <div *ngIf="!loading && analyticsData">
            <!-- Row 1: Distribution & Gender -->
            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                        <canvasjs-chart [options]="cohortDistributionOptions"
                            [styles]="{width: '100%', height: '360px'}"></canvasjs-chart>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                        <canvasjs-chart [options]="genderDistributionOptions"
                            [styles]="{width: '100%', height: '360px'}"></canvasjs-chart>
                    </div>
                </div>
            </div>

            <!-- Row 2: Retention & Packages -->
            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                        <canvasjs-chart [options]="retentionOptions"
                            [styles]="{width: '100%', height: '360px'}"></canvasjs-chart>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                        <canvasjs-chart [options]="packagePreferenceOptions"
                            [styles]="{width: '100%', height: '360px'}"></canvasjs-chart>
                    </div>
                </div>
            </div>

            <!-- Row 3: Dating Outcomes -->
            <div class="row mb-4">
                <div class="col-md-12">
                    <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                        <canvasjs-chart [options]="datingSuccessOptions"
                            [styles]="{width: '100%', height: '360px'}"></canvasjs-chart>
                    </div>
                </div>
            </div>

            <!-- Data Table -->
            <div class="row">
                <div class="col-md-12">
                    <div class="listingformat">
                        <div class="tabledatawrap table-responsive">
                            <h3>Detailed Cohort Data</h3>
                            <table class="table table-bordered table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th style="min-width: 150px;">Cohort</th>
                                        <th>Segment</th>
                                        <th>Total Users</th>
                                        <th>Active Paid</th>
                                        <th>Renewed</th>
                                        <th>Dropped Off</th>
                                        <th>Paid w/ Match</th>
                                        <th>Paid No Match</th>
                                        <th>Paid w/ Date</th>
                                        <th>Paid No Date</th>
                                        <th>Completed Dates</th>
                                        <th>Cancelled Dates</th>
                                        <th>No Show Dates</th>
                                        <th>Active Dates</th>
                                        <th>Confirmed Dates</th>
                                        <th>Paid w/ Date But Dropped</th>
                                        <!-- Dynamic Package Headers -->
                                        <th *ngFor="let pkg of packageHeaders">{{ pkg }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of tableData" [class.table-info]="row.cohort === 'Grand Total'"
                                        [class.font-weight-bold]="row.cohort === 'Grand Total'">
                                        <td><strong>{{ row.cohort }}</strong></td>
                                        <td>
                                            <span class="badge" [ngClass]="{
                                                    'badge-primary': row.segment === 'All',
                                                    'badge-info': row.segment === 'Male',
                                                    'badge-warning': row.segment === 'Female'
                                                }">
                                                {{ row.segment }}
                                            </span>
                                        </td>
                                        <td>{{ row.totalUsers }}</td>
                                        <td>{{ row.activePaid }}</td>
                                        <td>{{ row.renewed }}</td>
                                        <!-- Highlight high drop off -->
                                        <td
                                            [ngClass]="{'text-danger font-weight-bold': row.droppedOff > (row.totalUsers * 0.5)}">
                                            {{ row.droppedOff }}</td>
                                        <td>{{ row.paidWithMatch }}</td>
                                        <td>{{ row.paidNoMatch }}</td>
                                        <td>{{ row.paidWithDate }}</td>
                                        <td>{{ row.paidNoDate }}</td>
                                        <td>{{ row.completedDates }}</td>
                                        <td>{{ row.cancelledDates }}</td>
                                        <td>{{ row.noShowDates }}</td>
                                        <td>{{ row.activeDates }}</td>
                                        <td>{{ row.confirmedDates }}</td>
                                        <td>{{ row.paidWithDateButDropped }}</td>
                                        <!-- Dynamic Package Data -->
                                        <td *ngFor="let pkg of packageHeaders">
                                            {{ row.packages[pkg] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>